<template>
  <v-card class="sample-captcha col-12 col-sm-8 col-md-6 col-lg-4 mx-auto mt-4 pa-3">
    <section class="data-box">
      <input
        v-model="inputValue"
        placeholder="Soumettez votre captcha"
        class="input"
        type="text"
      />
    </section>
    <!-- <section>{{ data }}</section> -->
    <section class="captcha-box">
      <VueClientRecaptcha
        :value="inputValue"
        @getCode="getCaptchaCode"
        @isValid="checkValidCaptcha"
      />
    </section>
  </v-card>
</template>

<script>
import { ref, reactive } from "@vue/reactivity";
import VueClientRecaptcha from "vue-client-recaptcha";

export default {
  components: {
    VueClientRecaptcha,
  },
  emits: ["is-valid"],
  setup(_, { emit }) {
    const inputValue = ref(null);

    const data = reactive({
      captchaCode: null,
      isValid: false,
    });

    const getCaptchaCode = (value) => {
      data.captchaCode = value;
    };

    const emitIsValid = () => {
      console.log("Emitting isValid event");
      emit("is-valid", true);
    };

    const checkValidCaptcha = (value) => {
      data.isValid = value;
      if (value) {
        alert("Votre captcha est maintenant valide.");
        emitIsValid();
      }
    };

    return {
      inputValue,
      data,
      getCaptchaCode,
      checkValidCaptcha,
    };
  },
};
</script>

<style>
@import url("./../../node_modules/vue-client-recaptcha/dist/style.css");
.sample-captcha {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 100%;
  margin: 0 auto;
}
.sample-captcha .data-box .input {
  padding: 10px;
  border: 1px solid #f1f1f1;
  border-radius: 4px;
  width: 100%;
}
.sample-captcha .data-box .input:focus {
  background: #f0f0f00d;
  outline: none;
  box-shadow: inset 0 -2px 0 #0077ff;
}
.sample-captcha .data-box .data {
  width: 100%;
  margin-top: 10px;
  padding: 20px 0 20px 20px;
  background-color: #ebebeb;
  border-radius: 4px;
}
.sample-captcha .captcha-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px auto;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .sample-captcha {
    flex-direction: column;
    width: 95%;
    padding: 10px;
  }
  
  .sample-captcha .data-box {
    width: 100%;
    margin-bottom: 10px;
  }
  
  .sample-captcha .captcha-box {
    width: 100%;
    margin: 10px 0;
  }
  
  .sample-captcha .data-box .input {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .sample-captcha {
    width: 100%;
    padding: 5px;
  }
}
</style>
